export enum HydroStressLevel {
    LOW = "low",
    MEDIUM = "medium",
    HIGH = "high",
    UNDEFINED = "undefined"
}